export const OFFERING_CREATE_DRAFT_KEYS = {
  session: "coachli:create-session-draft",
  bundle: "coachli:create-bundle-draft",
  liveEvent: "coachli:create-live-event-draft",
  product: "coachli:create-product-draft",
  storeService: "coachli:create-store-service-draft",
  subscription: "coachli:create-subscription-draft",
} as const;

export type OfferingCreateDraftKey =
  (typeof OFFERING_CREATE_DRAFT_KEYS)[keyof typeof OFFERING_CREATE_DRAFT_KEYS];
